import { listTypes } from "../../registries/types.js"

/**
 * Names of the record types a link/record/type field can point at: every
 * registered type. Lists are records too, so a field can link to one.
 */
export function linkableTypeNames(): string[] {
  return listTypes().map((t) => t.name)
}
